import { EnvironmentUtilities } from 'frontend-toolkit';
import ENVIRONMENT from './environment';

const envUtils = new EnvironmentUtilities(window.location.host);

export const IS_PROD = ENVIRONMENT.indexOf('prod') !== -1;
export const IS_LOCAL = ENVIRONMENT.indexOf('local') !== -1;
export const IS_STAGING = ENVIRONMENT.indexOf('staging') !== -1;
export const IS_NOT_PROD = !IS_PROD;

export const APP_URL = {
  local: 'http://localhost:5502',
  test: 'http://localhost:5502',
  staging: `https://${envUtils.getStagingHost(
    'organization',
    'staging.organization.teamsnap.com'
  )}`,
  prod: 'https://organization.teamsnap.com',
}[ENVIRONMENT];

export const API_URL = {
  local: 'http://localhost:5302',
  test: 'http://localhost:5302',
  staging: `https://${envUtils.getStagingHost(
    'organization-api',
    'staging-organization-api.teamsnap.com'
  )}`,
  prod: 'https://organization-api.teamsnap.com',
}[ENVIRONMENT];

export const ADMIN_URL = {
  local: 'http://localhost:3012',
  test: 'http://localhost:3012',
  staging: 'https://staging.admin.teamsnap.com',
  prod: 'https://admin.teamsnap.com',
}[ENVIRONMENT];

export const ACCOUNTS_URL = {
  local: 'https://accounts.teamsnap.com',
  test: 'https://staging-prime.accounts.teamsnap.com',
  staging: `https://${envUtils.getStagingHost(
    'accounts',
    'staging-prime.accounts.teamsnap.com'
  )}`,
  prod: 'https://accounts.teamsnap.com',
}[ENVIRONMENT];

export const COGSWORTH_URL = {
  local: 'http://localhost:3004/',
  test: 'https://pod-sports-org.teamsnap.com:8443/',
  staging: `https://${envUtils.getStagingHost(
    'auth',
    'staging-cogsworth.teamsnap.com'
  )}/`,
  prod: 'https://auth.teamsnap.com/',
}[ENVIRONMENT];

export const CLASSIC_ADMIN_URL = {
  local: 'http://localhost:3001/admin',
  test: 'https://pod-sports-org.teamsnap.com:8443/admin',
  staging: `https://${envUtils.getStagingHost(
    'go-admin',
    'staging-classic-admin.teamsnap.com'
  )}/admin`,
  prod: 'https://go-admin.teamsnap.com/admin',
}[ENVIRONMENT];

export const CLIENT_ID = {
  local: 'hub_uid',
  test: 'hub_uid',
  staging: 'hub_uid',
  prod: '67746e2da03fe8cead89a30726c15368a95eb042441f8a6a469adcfead5479ea08fca1ae0272acbb4828c65e3a52f7a280539e7dc47f68218c11b0e41cc30636',
}[ENVIRONMENT];

export const TEAMSNAP_URL = {
  local: 'http://localhost:3001',
  test: 'http://localhost:3001',
  staging: `https://${envUtils.getStagingHost(
    'go',
    'staging-classic.teamsnap.com'
  )}`,
  prod: 'https://go.teamsnap.com',
}[ENVIRONMENT];

export const REGISTRANT_URL = {
  local: 'http://localhost:3000',
  test: 'http://localhost:3000',
  staging: `https://${envUtils.getStagingHost(
    'registration',
    'staging.registration.teamsnap.com'
  )}`,
  prod: 'https://registration.teamsnap.com',
}[ENVIRONMENT];

// This URL defines a healthcheck for determining a user's authentication
export const AUTH_URL = {
  local: 'http://localhost:5302/graphql',
  staging: `https://${envUtils.getStagingHost(
    'organization-api',
    'staging-organization-api.teamsnap.com'
  )}/graphql`,
  prod: 'https://organization-api.teamsnap.com/graphql',
}[ENVIRONMENT];

export const CHECKR_PARTNERS_URL = 'https://partners.checkr.com';
export const CHECKR_REPORTS_URL = 'https://partners.checkr.com';
export const CHECKR_CLIENT_ID = {
  local: '47695c6987534d685d8146c0',
  staging: '47695c6987534d685d8146c0',
  prod: 'da081e37b9756a2027446510',
}[ENVIRONMENT];

export const SENTRY_URL =
  'https://e90d81c7b44945b9bc253431f7f91137@o126035.ingest.sentry.io/1491155';

export const CHURNZERO_APP_KEY = {
  local: '3vL2S9LmLYNS7BEOUflDzQghvBSiOGOQB1IQH7NQKCA',
  staging: 'FxInBO0z5eBD-If1fw2HoQm5ZTX2k_9Z-pivYd88LCc',
  prod: 'Gog3KQ7lqZQtUBiLqWrdZZqpZPCKA-Qa0po3bWI8eZo',
}[ENVIRONMENT];

export const CHURNZERO_URL = {
  local: 'https://teamsnap-dev.us1app.churnzero.net',
  staging: 'https://teamsnap-qa.us1app.churnzero.net',
  prod: 'https://teamsnap.us1app.churnzero.net',
}[ENVIRONMENT];

export const TINY_MCE_API_KEY =
  'pj1z2kmead38q3zvr5cenu2zw8ypg469hugndipf3q742r27';

export const STRIPE_CLIENT_KEY = {
  local:
    'pk_test_51Dq5BXH3v9ZxQViIRIr5T0mX3fZxXXYszWlkHrurMnaCQq9UWoXw5jaX6OK7QkG9pALgvQ7zL8zNYXQRiVJKalAn00GyEUjvGu',
  staging:
    'pk_test_51Dq5BXH3v9ZxQViIRIr5T0mX3fZxXXYszWlkHrurMnaCQq9UWoXw5jaX6OK7QkG9pALgvQ7zL8zNYXQRiVJKalAn00GyEUjvGu',
  prod: 'pk_live_VOrEglkce2zbFN3dJ6aEmZ1c',
}[ENVIRONMENT];

export const TOURNAMENTS_ADMIN_URL = {
  local: 'http://localhost:8082',
  test: 'http://localhost:8082',
  staging: `https://${envUtils.getStagingHost(
    'tournaments',
    'test.tournaments.teamsnap.com'
  )}`,
  prod: 'https://tournaments.teamsnap.com',
}[ENVIRONMENT];

export const FUSION_APP_URL = {
  local: 'http://localhost:5304',
  test: 'http://localhost:5304',
  staging: 'https://staging.org.teamsnap.com',
  prod: 'https://org.teamsnap.com', // TODO: Update this to the correct URL once it is known
}[ENVIRONMENT];
